import {
  BreadcrumbItem,
  BreadcrumbLabel,
  BreadcrumbList,
  BreadcrumbSeparator,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  TabsHeader
} from '@criteria-labs/react'
import { type Service } from '@criteria-labs/docs-kit'
import { InspectorArticle, InspectorHeader } from '../article'
import { useParams, useRouter } from '../router'
import { ResourceEndpoints } from './ResourceEndpoints'
import { ResourceOverview } from './ResourceOverview'

export function ResourceDetail({ service }: { service: Service }) {
  const { push } = useRouter()

  const { resource_index } = useParams()
  if (resource_index === undefined) {
    return null
  }
  const resourceIndex = parseInt(resource_index)
  const resource = service.resources[resourceIndex]

  return (
    <InspectorArticle>
      <Tabs>
        <InspectorHeader className="space-y-3">
          <BreadcrumbList className="min-h-10">
            <BreadcrumbItem onClick={() => push('/')}>
              <BreadcrumbLabel>API</BreadcrumbLabel>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLabel>{resource.tag.name ?? 'Resource'}</BreadcrumbLabel>
            </BreadcrumbItem>
          </BreadcrumbList>
          <TabsHeader className="flex items-baseline gap-x-6">
            <Heading>{resource.tag.name ?? 'Resource'}</Heading>
            <TabList>
              <Tab>Overview</Tab>
              <Tab>Endpoints</Tab>
            </TabList>
          </TabsHeader>
        </InspectorHeader>
        <TabPanels>
          <TabPanel className="space-y-6">
            <ResourceOverview resource={resource} resourceIndex={resourceIndex} />
          </TabPanel>
          <TabPanel>
            <ResourceEndpoints resource={resource} resourceIndex={resourceIndex} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </InspectorArticle>
  )
}
